import { Route, Switch } from "react-router-dom";

import AllQuotes from "./pages/AllQuotes";
import QuoteDetail from "./pages/QuoteDetail";
import NewQuote from "./pages/NewQuote";
// import NotFound from "./pages/NotFound";
import Layout from "./components/layout/Layout";
//.

function App() {
  return (
    <Layout>
      <Switch>
        <Route path="/Quoates-App/" exact>
          <AllQuotes />
        </Route>
        <Route path="/quotes" exact>
          <AllQuotes />
        </Route>
        <Route path="/quotes/:quoteId">
          <QuoteDetail />
        </Route>
        <Route path="/new-quote">
          <NewQuote />
        </Route>
        <Route path="*">
          <AllQuotes />
        </Route>
      </Switch>
    </Layout>
  );
}

export default App;
